import { getAddressConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Address/Address.config';
import { getAlternateNameConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/AlternateName/AlternateName.config';
import { getCreditReportingConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/CreditReporting/CreditReporting.config';
import { getConfigFields as getCounselingConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/Counseling/Counseling.config';
import { getConfigFields as getDemographicConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/Demographic/Demographic.config';
import { getConfigFields as getFinancesConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/Finances/Finances.config';
import { getConfigFields as getHomeownershipConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/HomeownershipEducationAndHousingCounseling/HomeownershipEducationAndHousingCounseling.config';
import { getConfigFields as getLanguagePreferenceConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/LanguagePreference/LanguagePreference.config';
import { getConfigFields as getMilitaryConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/MilitaryServices/MilitaryServices.config';
import { getConfigFields as getPropertyAndLoanDeclConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/Declarations/PropertyAndLoan/PropertyAndLoan.config';
import { getPersonalInfoConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/PersonalInfo/PersonalInfo.config';
import { getPoaConfigFields } from '../../tabs/borrowers/EditEntityModal/Content/MainContent/Borrower/POA/POA.config';
import { BORROWING_ENTITY_TABS_HREF } from '../../tabs/borrowers/EditEntityModal/EditEntityModal.constants';
import { closingInformationFields } from '../../tabs/loanClosingCDS/shared/ClosingInformation/ClosingInformationViewer.config';
import {
  closingAgentFields,
  fundingInformationFields,
  furtherCreditToInformationFields,
  wireToInformationFields,
} from '../../tabs/loanClosingCDS/shared/FundingInformation/FundingInformationViewer.config';

import { extractSearchableFields } from './fields.utils';
import { DUMMY_ENTITY_ID } from './sections.constants';

export const BORROWER_SECTION_FIELD_DEFINITIONS = {
  [BORROWING_ENTITY_TABS_HREF.BORROWER]: extractSearchableFields(
    getPersonalInfoConfigFields({ entityId: DUMMY_ENTITY_ID }),
  ),
  [BORROWING_ENTITY_TABS_HREF.ADDRESS]: extractSearchableFields(
    getAddressConfigFields({ entityId: DUMMY_ENTITY_ID, isPreviousResidence: false }),
  ),
  [BORROWING_ENTITY_TABS_HREF.CREDIT_REPORTING]: extractSearchableFields(
    getCreditReportingConfigFields({ entityId: DUMMY_ENTITY_ID }),
  ),
  [BORROWING_ENTITY_TABS_HREF.ALTERNATE_NAMES]: extractSearchableFields(
    getAlternateNameConfigFields({ entityId: DUMMY_ENTITY_ID }),
  ),
  [BORROWING_ENTITY_TABS_HREF.POA]: extractSearchableFields(
    getPoaConfigFields({ entityId: DUMMY_ENTITY_ID }),
  ),
  [BORROWING_ENTITY_TABS_HREF.DECLARATIONS]: [
    ...extractSearchableFields(getPropertyAndLoanDeclConfigFields({ entityId: DUMMY_ENTITY_ID })),
    ...extractSearchableFields(getFinancesConfigFields({ entityId: DUMMY_ENTITY_ID })),
    ...extractSearchableFields(getMilitaryConfigFields({ entityId: DUMMY_ENTITY_ID })),
    ...extractSearchableFields(getLanguagePreferenceConfigFields({ entityId: DUMMY_ENTITY_ID })),
    ...extractSearchableFields(getDemographicConfigFields({ entityId: DUMMY_ENTITY_ID })),
    ...extractSearchableFields(getHomeownershipConfigFields({ entityId: DUMMY_ENTITY_ID })),
    ...extractSearchableFields(getCounselingConfigFields({ entityId: DUMMY_ENTITY_ID })),
  ],
};

const deriveSearchFieldsFromViewerConfig = (configFields, { labelPrefix } = {}) =>
  Object.entries(configFields).map(([key, field]) => ({
    fieldId: key,
    label: [labelPrefix, field.label.replace(/:$/, '')].filter(Boolean).join(' '),
    dataPath: field.name,
  }));

export const LOAN_CLOSING_SECTION_FIELD_DEFINITIONS = {
  'closing-information': deriveSearchFieldsFromViewerConfig(closingInformationFields),
  'funding-information': [
    ...deriveSearchFieldsFromViewerConfig(fundingInformationFields),
    ...deriveSearchFieldsFromViewerConfig(closingAgentFields),
    ...deriveSearchFieldsFromViewerConfig(wireToInformationFields),
    ...deriveSearchFieldsFromViewerConfig(furtherCreditToInformationFields, {
      labelPrefix: 'Further Credit',
    }),
  ],
};
